import React, { Component } from "react";
import {
    particularReportsdata,
    setReport,
    getTotalJobPacks,
    getJobYears,
    setSortTableType,
    setSortTableKey,
    setSortTableAs,
} from "./actions";
import {
    selectJobYears,
    totalReportCount,
    selectSortTableType,
    selectSortTableKey,
    selectSortTableAs,
} from "./selectors";
import {
    Typography,
    Button,
    TablePagination,
    withWidth,
    MenuItem,
    InputLabel,
    Select,
    Tooltip,
} from "@material-ui/core";
import TableList from "../../Utilities/Helpers/TableList/TableList";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import tableConfig from "./tableConfig";
import { Row, Col } from "reactstrap";

import LockIcon from "@material-ui/icons/Lock";
import UnlockIcon from "@material-ui/icons/LockOpen";

import "./submittedReportsStyles.css";
import { connect } from "react-redux";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import _ from "lodash";

import {
    TrendingFlat as TrendingFlatIcon,
    Update as StatusIcon,
} from "@material-ui/icons";
import moment from "moment";

import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

let reportType = "";
let timeStamp = "";
let isSelected = "false";

class TableData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportNotPresent: false,
            moveModal: false,
            userId: "",
            selectedJobId: "",
            reportData: [],
            year: "",
            month: "",
            modalStatus: false,
            statusModal: false,
            status: "unviewed",
            statusModalData: false,
        };
        this.props.getJobYears();
    }
    getStatusColor = (status) => {
        if (status === undefined || status === null) return "green";
        if (status === "offline") return "red";
        if (status === "online") return "green";
    };
    render() {
        const {
            tableData,
            users,
            rowsPerPage,
            page,
            setRowsPerPage,
            setPage,
            reportTitles,
            setReportStatus,
            permissions,
            setModalInfo,
            jobIDs,
            particularReports,
            year1,
            month1,
            jobYears,
        } = this.props;
        return (
            <>
                <div
                    style={{ display: "block", width: "100%", height: "auto" }}
                >
                    <TablePagination
                        colSpan={12}
                        ActionsComponent={TablePaginationHelper}
                        count={this.props.reportCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={(event, page) => setPage(page)}
                        onChangeRowsPerPage={(event) =>
                            setRowsPerPage(event.target.value)
                        }
                        rowsPerPageOptions={[50, 100]}
                    />
                </div>
                <TableList
                    width={this.props.width}
                    listData={tableData}
                    tableConfig={tableConfig}
                    permissions={permissions}
                    enableSorting
                    setSortTableType={this.props.setSortTableType}
                    setSortTableAs={this.props.setSortTableAs}
                    setSortTableKey={this.props.setSortTableKey}
                    sortTableKey={this.props.sortTableKey}
                    sortTableType={this.props.sortTableType}
                    isReports={true}
                    deleteAction={(data) => {
                        if (!data.uneditable)
                            setModalInfo({
                                status: "",
                                reportType: data.report_type,
                                timestamp: data.timestamp,
                                uid: data.uid,
                                state: true,
                                type: "delete",
                                subjectChild: data.subject_child,
                                subjectName: data.subject_name,
                            });
                    }}
                    selectActionData={(data, actType) => {
                        if (actType === "status" && data && !data.uneditable) {
                            if (
                                this.props.permissions[data.report_type].update
                            ) {
                                this.setState({
                                    statusModal: true,
                                    statusModalData: data,
                                    status: data.status
                                        ? data.status
                                        : "unviewed",
                                });
                            }
                        } else if (actType === "uneditable" && data) {
                            setModalInfo({
                                status: !data.uneditable,
                                uid: data.uid,
                                reportType: data.report_type,
                                timestamp: data.timestamp,
                                type: "edit",
                                state: true,
                            });
                        } else if (
                            actType === "move_report" &&
                            data &&
                            !data.uneditable
                        ) {
                            this.props.particularReportsdata(data.uid);
                            this.setState({
                                moveModal: true,
                            });
                            this.setState({
                                userId: data.uid,
                            });
                            reportType = data.report_type;
                            timeStamp = data.timestamp;
                        }
                    }}
                    customActions={(data) => {
                        return {
                            status: (
                                <Tooltip title="Status">
                                    <span>
                                        <StatusIcon />
                                    </span>
                                </Tooltip>
                            ),
                            uneditable: data.uneditable ? (
                                <Tooltip title="Unlock">
                                    <LockIcon />
                                </Tooltip>
                            ) : (
                                <Tooltip title="Lock">
                                    <UnlockIcon />
                                </Tooltip>
                            ),
                            move_report: (
                                <Tooltip title="Move Reports">
                                    <span>
                                        <TrendingFlatIcon />
                                    </span>
                                </Tooltip>
                            ),
                        };
                    }}
                    showEditAction={false}
                    customCellKeys={[
                        "report_type",

                        "job_pack_id",
                        "worksheet_status",
                        "other",
                    ]}
                    customCells={(data, cellKey) => {
                        if (cellKey === "report_type") {
                            return reportTitles[data[cellKey]];
                        } else if (cellKey === "user_name") {
                            let user = _.find(users, { uid: data.uid });
                            return user ? user.user_name : "N/A";
                        } else if (cellKey === "job_pack_id") {
                            return data.subject_name === "reports"
                                ? "N/A"
                                : data.subject_child;
                        } else if (cellKey === "worksheet_status") {
                            return data.worksheet_status
                                ? data.worksheet_status
                                : "Unviewed";
                        } else if (cellKey === "other") {
                            return (
                                <div>
                                    {typeof data.client_name === "undefined" ||
                                    data.client_name === "required" ? (
                                        <>
                                            <b>Client Name: </b>
                                            <span>N/A</span>
                                        </>
                                    ) : (
                                        <>
                                            <b>Client Name: </b>
                                            <span>{data.client_name}</span>
                                        </>
                                    )}
                                    <br />
                                    <b>URN: </b>
                                    <span>{data.urn ? data.urn : "N/A"}</span>
                                    <br />
                                    <b>Connection Status: </b>
                                    <span
                                        style={{
                                            color: this.getStatusColor(
                                                data.connection_status
                                            ),
                                        }}
                                    >
                                        {data.connection_status === undefined
                                            ? data.connection_status
                                            : "online"}
                                    </span>{" "}
                                    
                                    
                                </div>
                            );
                        }
                    }}
                />
                <Modal
                    isOpen={this.state.moveModal}
                    backdropTransition={{
                        timeout: 1300000000,
                    }}
                >
                    <ModalHeader>Move Reports</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Typography
                                style={{
                                    marginLeft: "15px",
                                }}
                            >
                                {" "}
                                Do you wanna move this report from standalone to
                                jobpack?{" "}
                            </Typography>
                        </Row>
                        <br />
                        <Row>
                            <Col>
                                <InputLabel for="jobyear">
                                    Select Jobpack Year:&nbsp;
                                </InputLabel>
                                <Select
                                    id="jobyear"
                                    value={this.state.year}
                                    style={{
                                        minWidth: "150px",
                                    }}
                                    onChange={(event) => {
                                        let jobNumber = event.target.value;
                                        this.setState({
                                            year: jobNumber,
                                        });
                                    }}
                                >
                                    {jobYears &&
                                        Object.values(jobYears).map((e) => {
                                            return (
                                                <MenuItem value={e}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col>
                                <InputLabel for="jobname">
                                    Enter Jobpack Month:&nbsp;
                                </InputLabel>
                                <Select
                                    id="month"
                                    value={this.state.month}
                                    style={{
                                        minWidth: "150px",
                                    }}
                                    onChange={(event) => {
                                        let jobMonth = event.target.value;
                                        this.setState({
                                            month: jobMonth,
                                        });
                                    }}
                                >
                                    <MenuItem value="jan">January</MenuItem>
                                    <MenuItem value="feb">February </MenuItem>
                                    <MenuItem value="mar">March</MenuItem>
                                    <MenuItem value="apr">April</MenuItem>
                                    <MenuItem value="may">May</MenuItem>
                                    <MenuItem value="jun">June</MenuItem>
                                    <MenuItem value="jul">July</MenuItem>
                                    <MenuItem value="aug">August</MenuItem>
                                    <MenuItem value="sep">September</MenuItem>
                                    <MenuItem value="oct">October</MenuItem>
                                    <MenuItem value="nov">November</MenuItem>
                                    <MenuItem value="dec">December</MenuItem>
                                </Select>
                                &nbsp;&nbsp;
                                <Button
                                    style={{
                                        marginLeft: "20px",
                                    }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.setState({
                                            modalStatus: true,
                                        });
                                        this.props.getTotalJobPacks(
                                            this.state.year,
                                            this.state.month
                                        );
                                    }}
                                    disabled={
                                        this.state.year === "" ||
                                        this.state.month === ""
                                            ? true
                                            : false
                                    }
                                >
                                    Confirm
                                </Button>
                            </Col>
                        </Row>
                        <br />
                        {this.state.modalStatus === false ? (
                            ""
                        ) : (
                            <Row>
                                <div>
                                    <Col>
                                        <InputLabel>
                                            Select Jobpack:&nbsp;&nbsp;
                                        </InputLabel>
                                        <Select
                                            multiple={false}
                                            style={{
                                                width: "100px",
                                            }}
                                            value={this.state.selectedJobId}
                                            onChange={(event) => {
                                                isSelected = "true";
                                                let newGroup =
                                                    event.target.value;
                                                this.setState({
                                                    selectedJobId: newGroup,
                                                });
                                            }}
                                        >
                                            {jobIDs &&
                                                jobIDs.map((e, i) => {
                                                    return (
                                                        <MenuItem
                                                            value={e}
                                                            key={i}
                                                            style={{
                                                                borderBottom:
                                                                    "2px solid black",
                                                            }}
                                                        >
                                                            Id: {e.id}
                                                            <br></br>
                                                            Client Name:{" "}
                                                            {e.client_name}
                                                            <br></br>
                                                            Location:{" "}
                                                            {e.address}
                                                        </MenuItem>
                                                    );
                                                })}
                                        </Select>
                                    </Col>
                                </div>
                            </Row>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        moveModal: false,
                                    });
                                    this.setState({
                                        selectedJobId: "",
                                    });
                                    this.setState({
                                        userId: "",
                                    });
                                    this.setState({
                                        modalStatus: false,
                                        year: "",
                                        month: "",
                                    });
                                }}
                            >
                                Close
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.props.setReport(
                                        this.state.selectedJobId,
                                        particularReports,
                                        timeStamp,
                                        reportType,
                                        this.state.userId,
                                        this.state.year,
                                        this.state.month,
                                        year1,
                                        month1
                                    );
                                    this.setState({
                                        moveModal: false,
                                    });
                                    this.setState({
                                        selectedJobId: "",
                                    });
                                    this.setState({
                                        modalStatus: false,
                                        year: "",
                                        month: "",
                                    });
                                    isSelected = "false";
                                    this.setState({
                                        userId: "",
                                    });
                                }}
                                disabled={isSelected === "false" ? true : false}
                            >
                                Submit
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
                <Modal
                    isOpen={this.state.statusModal}
                    backdropTransition={{
                        timeout: 1300000000,
                    }}
                >
                    <ModalHeader>Report Status</ModalHeader>
                    <ModalBody>
                        <InputLabel for="jobname">Status</InputLabel>
                        <Select
                            id="status"
                            value={this.state.status}
                            style={{
                                minWidth: "150px",
                            }}
                            onChange={(event) => {
                                let stat = event.target.value;
                                this.setState({
                                    status: stat,
                                });
                            }}
                        >
                            <MenuItem default value={undefined}>
                                Unviewed
                            </MenuItem>
                            <MenuItem value="viewed">Viewed</MenuItem>
                            <MenuItem value="unviewed">Unviewed</MenuItem>
                            <MenuItem value="invoiced">Invoiced</MenuItem>
                        </Select>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        statusModal: false,
                                        status: "",
                                    });
                                }}
                            >
                                Close
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    let month = moment(
                                        this.state.statusModalData.timestamp,
                                        "DD-MM-YYYY HH:mm:ss"
                                    )
                                        .format("MMM")
                                        .toLowerCase();
                                    let year = moment(
                                        this.state.statusModalData.timestamp,
                                        "DD-MM-YYYY HH:mm:ss"
                                    ).format("YYYY");
                                    setReportStatus({
                                        uid: this.state.statusModalData.uid,
                                        timestamp: this.state.statusModalData
                                            .timestamp,
                                        reportType: this.state.statusModalData
                                            .report_type,
                                        status: this.state.status,
                                        year,
                                        month,
                                    });

                                    this.setState({
                                        statusModal: false,
                                        statusModalData: false,
                                    });
                                }}
                            >
                                Submit
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default connect(
    (store) => {
        return {
            jobYears: selectJobYears(store),
            reportCount: totalReportCount(store),
            sortTableType: selectSortTableType(store),
            sortTableKey: selectSortTableKey(store),
            sortTableAs: selectSortTableAs(store),
        };
    },
    {
        particularReportsdata,
        setReport,
        getTotalJobPacks,
        getJobYears,
        setActivity,
        setSortTableType,
        setSortTableKey,
        setSortTableAs,
    }
)(withWidth()(TableData));
